<div class="av-input-indicator" *ngIf="stbState$ | async as stbState">
  <div *ngIf="stbState.currentInputType">
    <div [ngSwitch]="stbState.currentInputType">
      <span *ngSwitchCase="1">DVB-T/{{stbState.currentInputIndex}}</span>
      <span *ngSwitchCase="6">HDMI/{{stbState.currentInputIndex}}</span>
      <span *ngSwitchCase="8">OTHER/{{stbState.currentInputIndex}}</span>
    </div>
  </div>
</div>
